import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * ResearcherWelcome — custom start screen for the 🔬 Researcher agent.
 *
 * This is an independent copy of DefaultWelcome, intentionally decoupled
 * so it can be freely customised (logo, headline, tagline, illustration…)
 * without affecting any other agent's welcome screen.
 *
 * Current state: same layout as DefaultWelcome — ready for customisation.
 */
const ResearcherWelcome: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      height="100%"
      width="100%"
      maxWidth={{ xs: '550px', sm: '680px' }}
      mx="auto"
      gap={1}
      px={3}
      pt={8}
    >
      <Box
        component="img"
        src="/images/Bolt - 435x187.png"
        alt="Bolt Logo"
        sx={{
          width: { xs: '250px', sm: '380px' },
          height: 'auto',
          mb: 1,
        }}
      />
      <Typography
        variant="h5"
        fontWeight={600}
        color="text.primary"
        textAlign="center"
        sx={{ mb: 0.5 }}
      >
        Build Organize Learn Transform
      </Typography>
      <Typography
        variant="h6"
        fontWeight={400}
        color="text.secondary"
        textAlign="center"
        sx={{ mb: 10 }}
      >
        🔬 Researcher agent
      </Typography>
      <Typography
        variant="h6"
        fontWeight={400}
        color="text.primary"
        textAlign="center"
      >
        Let's research together! Ask me anything and I'll dive into the web and company sources. Don't forget to enable the connectors.
      </Typography>
    </Box>
  );
};

export default ResearcherWelcome;
